<template>
  <van-dialog class="bdc-exam-dialog"
              ref="dialog"
              :is-disable-close="true"
              :is-show-footer="false">
    <template slot="title">
      <van-quizzes-toolbar :title="navigation" :is-forced="false" @close="close" />
    </template>
    <div
      :key="renderKey"
      class="bdc-exam-dialog-wrap"
      :class="{diff: isRenderDiffExam}"
      ref="wrap"
    >
      <van-exam
        :class="{'before-exam': isRenderDiffExam}"
        :exercises="exercises"
        :is-preview="isPreview"
        :control="false"
        :is-comparison="isComparison"
        :scene="scene"
      >
        <span class="describe" slot="describe" v-if="isRenderDiffExam">
          <span>(学前)</span>
          <span>{{beforeScore}} 分</span>
        </span>
      </van-exam>
      <van-exam
        class="after-exam"
        v-if="isRenderDiffExam"
        :is-comparison="isComparison"
        :exercises="extendExercises"
        :is-preview="isPreview"
        :scene="scene"
        :control="false"
      >
        <span class="describe" slot="describe" v-if="isRenderDiffExam">
          <span>(学后)</span>
          <span>{{afterScore}} 分</span>
        </span>
      </van-exam>
    </div>
  </van-dialog>
</template>

<script>
import VanDialog from '@/components/common/Dialog.vue';
import VanQuizzesToolbar from '@/components/quizzes/QuizzesToolbar.vue';
import VanExam from '@/components/quizzes/bdc/Exam.vue';

export default {
  props: {
    exercises: {
      type: Array,
      isRequired: true,
    },
    extendExercises: {
      type: Array,
      default: () => ([]),
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
    navigation: {
      type: String,
      default: '',
    },
    scores: {
      type: Array,
      default: () => ([]),
    },
    scene: {
      type: Number,
      default: 2,
    },
    isComparison: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      renderKey: 0, // 每次打开dialog重新渲染组件
    };
  },
  components: {
    VanQuizzesToolbar,
    VanDialog,
    VanExam,
  },
  computed: {
    isRenderDiffExam() {
      return this.extendExercises && this.extendExercises.length;
    },
    beforeScore() {
      const [beforeScore] = this.scores;
      return beforeScore;
    },
    afterScore() {
      const [, afterScore] = this.scores;
      return afterScore;
    },
  },
  methods: {
    open() {
      this.renderKey += 1;
      this.$refs.dialog.open();
    },
    close() {
      this.$refs.dialog.close();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/tip-line.scss';

  .bdc-exam-dialog {
    user-select: none;
    .bdc-exam-dialog-wrap {
      box-sizing: border-box;
      height: 736px;
      overflow-y: auto;
      .describe {
        span {
          &:first-child {
            color: $primary;
          }
          &:last-child {
            color: $danger;
            margin-left: 10px;
          }
        }
      }
      &.diff {
        .exam {
          float: left;
          width: 50%;
        }
      }
    }
    /deep/ .el-dialog {
      width: 1400px!important;
      height: 788px!important;
      max-height: 788px;
      .el-dialog__body {
        .content {
          padding: 0!important;
        }
      }
      .el-dialog__footer {
        padding: 5px 20px;
        border: 0;
        .dialog-footer {
          min-height: 55px;
        }
      }
    }
  }
  @media screen and (max-device-height: 1079px){
    .bdc-exam-dialog {
      .bdc-exam-dialog-wrap {
        height: 510px !important;
        .table-wrap {
          height: 220px !important;
        }
      }
      /deep/ .el-dialog {
        width: 1000px !important;
        height: 563px !important;
        .el-dialog__body {
          .content {
            padding: 0;
          }
        }
        .el-dialog__footer {
          padding: 5px 20px;
          border: 0;
          .dialog-footer {
            min-height: 55px;
          }
        }
      }
    }
  }
</style>
